/** @jsx jsx */
import { jsx, NavLink } from "theme-ui";
import React, { PropsWithChildren } from "react";
import { Link as GatsbyLink } from "gatsby";
import { Link } from "@theme-ui/components";
//import scrollToElement from "scroll-to-element";
import { StyleProps } from "../../types/types";

export const isBrowser = typeof window !== "undefined";

export type RockitLinkProps = {
  to: string;
  type?: "Internal" | "External";
  isNavLink?: boolean;
  openInNewTab?: boolean;
} & StyleProps &
  PropsWithChildren;
export const RockitLink: React.FC<RockitLinkProps> = ({
  to,
  children,
  type,
  isNavLink,
  className,
  openInNewTab = false,
}) => {
  const isInternal = /^\/(?!\/)/.test(to);
  type = isInternal ? "Internal" : "External";
  if (to.includes(".pdf")) {
    type = "External";
  }
  //type will be depricated and it will be termined based on the link

  isNavLink = isNavLink ? isNavLink : false;

  if (isNavLink) {
    return (
      <GatsbyLink
        sx={{ variant: "links.nav" }}
        to={to}
        activeClassName="active"
        target={openInNewTab ? "blank" : "self"}
      >
        {children}
      </GatsbyLink>
    );
  }

  if (type === "Internal" && !isNavLink) {
    return (
      <GatsbyLink
        to={to}
       
        //  onClick={() => {
        //    linkClick(to);
        //   }}
        className={className}
        target={openInNewTab ? "blank" : "self"}
      >
        {children}
      </GatsbyLink>
    );
  } else {
    /* default external to blank target*/

    return (
      <Link className={className} href={to} target="blank">
        {children}
      </Link>
    );
  }
};

export default RockitLink;
